<script setup lang="ts">
import type { SplitterPanelProps } from "./splitter.types";
import { useSplitterPanel } from "composables/useSplitter";

const props = withDefaults(defineProps<SplitterPanelProps>(), {
  minSize: 0,
  maxSize: 100,
  collapsible: false,
  collapsedSize: 0,
});

const { classes, style, panelId } = useSplitterPanel({ props });
</script>

<template>
  <div :id="panelId" part="panel" :class="classes" :style="style" class="e-splitter-panel">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
